var map = {
	"./1.webp": 8310,
	"./2.webp": 9504,
	"./3.webp": 6334,
	"./4.webp": 5609,
	"./5.webp": 6338,
	"./6.webp": 4085,
	"./7.webp": 8358,
	"./8.webp": 9678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;